
/**
 * The keys of relevant projects stored in CMX / the translation service.
 */
export enum ProjectKeys {
    ARCADE_UI = 'arcade-ui',
}
